import React from 'react'
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Contact from '../Contact/Contact';

const Newsletter = () => {
  return (
    <div className='newsletter-section' id="newsletter-section">
      <Container>
        <Typography variant="h4" gutterBottom>
          Stay Connected
        </Typography>

        <div className="newsletter-container">
          <div className="newsletter-form-area">
            <Typography variant="body1" gutterBottom>
              Be the first to hear about Drive Plus updates!
            </Typography>
            <div className='subscribe-form-section'>
              <TextField id="outlined-basic" className='subscribe-form' label="Email" variant="outlined" />
              <Button className='subscribe' size='large'>Subscribe</Button>
            </div>
          </div>

          <Contact />
        </div>
      </Container>
    </div>
  )
}

export default Newsletter